import {AmsListItemBase} from './AmsListItemBase';
import * as XCol from '../../framework.core/XExportColumn';

export class AmsVoyageListItem extends AmsListItemBase {
    id: string = '';
    amsStatus: string = '';
    userId: string = '';
    block: number | null = null;
    vesselName: string = '';
    voyage: string = '';
    lloyds: string = '';
    loadPort: string = '';
    etd: string | null = null;
    fromETD: string | null = null;
    toETD: string | null = null;
    firstPort: string = '';
    eta: string | null = null;
    fromETA: string | null = null;
    toETA: string | null = null;
    lastPort: string = '';
    lastETD: string | null = null;
    fromLastETD: string | null = null;
    toLastETD: string | null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true, filterable: false  }),
        XCol.Create({ col: 1, text: 'AMS ID', width: 80, dataIndex: 'id', align: XCol.XAlignType.Right, hiddenInColumnSetup: true }),
        XCol.Create({ col: 2, text: 'S', width: 40, dataIndex: 'amsStatus', align: XCol.XAlignType.Center, hiddenInColumnSetup: true }),
        XCol.Create({ col: 3, text: 'User', width: 100, dataIndex: 'userId'}),
        XCol.Create({ col: 4, text: 'Block', width: 40, dataIndex: 'block', type: XCol.XCellType.StrBool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 5, text: 'Vessel Name', width: 120, dataIndex: 'vesselName', defaultColumnFocus : true}),
        XCol.Create({ col: 6, text: 'Voyage #', width: 80, dataIndex: 'voyage'}),
        XCol.Create({ col: 7, text: 'Lloyds', width: 80, dataIndex: 'lloyds'}),
        XCol.Create({ col: 8, text: 'Loading Port', width: 100, dataIndex: 'loadPort'}),
        XCol.Create({ col: 9, text: 'ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 10, text: 'Foreign Last Port', width: 100, dataIndex: 'lastPort'}),
        XCol.Create({ col: 11, text: 'ETD', width: 75, dataIndex: 'lastETD', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 12, text: 'First US Port', width: 100, dataIndex: 'firstPort'}),
        XCol.Create({ col: 13, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: AmsVoyageListItem.prototype.id, orderByAscending: false };

    public static formatData(data: AmsVoyageListItem[]) {
        return data.map((d: AmsVoyageListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        etd: {from: 'fromETD', to: 'toETD'},
        lastETD: {from: 'fromLastETD', to: 'toLastETD'},
        eta: {from: 'fromETA', to: 'toETA'},
    }
}
